import React from 'react';
import { Tooltip } from '@fluentui/react-components';
import { Mail16Regular, Call16Regular, Chat16Regular } from '@fluentui/react-icons';
import TentAvatar from './TentAvatar';
import {
    formatLocalTime,
    formatWorkstreamsLabel,
    getEffectiveLocation,
    getEffectiveTimezone,
} from '../../utils/tentTimezoneUtils';
import styles from './css/index.module.css';
import chatStyles from './css/chat.module.css';

const TentRow = ({
    member,
    selected,
    onToggleSelect,
    onOpenMember,
    onEmail,
    onMessage,
    showMessageLabel = false,
    showCheckbox = true,
}) => {
    const timezone = getEffectiveTimezone(member);
    const location = getEffectiveLocation(member) || '—';
    const localTime = formatLocalTime(timezone);
    const workstreamsLabel = formatWorkstreamsLabel(member.workstreams);

    return (
        <tr>
            {showCheckbox && (
                <td className={styles.checkboxCell}>
                    <input
                        type="checkbox"
                        checked={selected}
                        onChange={() => onToggleSelect(member.user_id)}
                        aria-label={`Select ${member.full_name}`}
                    />
                </td>
            )}
            <td className={styles.nameColumnCell}>
                <div className={styles.nameCell} onClick={() => onOpenMember(member)} role="button" tabIndex={0}>
                    <span className={styles.avatarWrap}>
                        <TentAvatar name={member.full_name} size={32} margin="0" />
                    </span>
                    <div className={styles.nameText}>
                        <div className={styles.memberName}>{member.full_name}</div>
                        <div className={styles.memberEmail}>{member.email}</div>
                    </div>
                </div>
            </td>
            <td className={styles.textColumnCell}>{member.organisation || '—'}</td>
            <td className={styles.textColumnCell}>{member.job_title || '—'}</td>
            <td className={styles.textColumnCell} title={(member.workstreams || []).join(', ')}>
                {workstreamsLabel}
            </td>
            <td className={styles.textColumnCell}>{location}</td>
            <td className={styles.textColumnCell}>{localTime}</td>
            <td className={styles.contactColumnCell}>
                <div className={styles.contactCell}>
                    <button type="button" className={styles.iconButton} onClick={() => onEmail([member])} aria-label="Email">
                        <Mail16Regular />
                    </button>
                    {onMessage ? (
                        showMessageLabel ? (
                            <button type="button" className={chatStyles.messageBtn} onClick={() => onMessage(member)}>
                                <Chat16Regular />
                                Message
                            </button>
                        ) : (
                            <button
                                type="button"
                                className={styles.iconButton}
                                onClick={() => onMessage(member)}
                                aria-label={`Message ${member.full_name}`}
                            >
                                <Chat16Regular />
                            </button>
                        )
                    ) : null}
                    {member.phone ? (
                        <Tooltip content={member.phone} relationship="label">
                            <a href={`tel:${member.phone}`} className={styles.iconButton} aria-label={`Call ${member.full_name}`}>
                                <Call16Regular />
                            </a>
                        </Tooltip>
                    ) : null}
                </div>
            </td>
        </tr>
    );
};

export default TentRow;
